import { HelpProps } from './types';
import { isBrowser } from "@apps/Shared/Utils/Utils";
import { KEYS } from "@apps/Shared/Constants/KeyCodes";
import { useTranslation } from 'react-i18next';
import Icon from "@sharedComponents/Icon";
import QuestionBubble from './QuestionBubble';
import React, { useState } from 'react';

const Help = (props: HelpProps) => {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();

    const fullscreenClass = props.fullscreen ? 'fullscreen' : '';

    const onOpen = () => {
        setOpen(true)
        if (isBrowser) {
            const content: HTMLElement | null = document.querySelector(
                '.help-content'
            );
            content && content.focus && content.focus();
        }
    }

    const onClose = () => {
        setOpen(false);
    }

    return (
        <div className={`help ${open ? 'open' : ''}`}>
            <div
                tabIndex={0}
                role="button"
                onKeyDown={e => e.keyCode === KEYS.enter && setOpen(true)}
                onClick={onOpen}
                className={`help__corner-button ${fullscreenClass}`}
            >
                <span>{t('help.header')}</span>
                <div className='help__bubble-wrapper'>
                    <QuestionBubble size="lg" />
                </div>
            </div>

            <div className={`content-wrapper ${open ? 'open' : ''}`}>
                <div className='content-wrapper__header'>
                    <span className='content-wrapper__text'>
                        {t('help.header')}
                        <span className='content-wrapper__bubble-wrapper'>
                            <QuestionBubble size="sm" />
                        </span>
                    </span>
                </div>
                <div className='content-wrapper__content help-content' dangerouslySetInnerHTML={{__html: props.content}}>
                </div>
                <div className='content-wrapper__bottom'>
                    <div className='content-wrapper__scroll-fade' />
                    <div className='content-wrapper__close'
                        tabIndex={0}
                        role="button"
                        onKeyDown={e => e.keyCode === KEYS.enter && onClose()}
                        onClick={onClose}>
                        <Icon iconName="close" color="#0094bf" />
                        <span>{t('button.close')}</span>
                    </div>
                </div>
            </div>

            <div className={`help__shadow ${open ? 'open' : ''}`} />
        </div>
    )
}

export default Help;